module.exports = __webpack_public_path__ + "static/media/socials-instagram-gray.45eef44f.svg";